import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

export const selectResetEmailModalOpen = (s) => s.landing.resetEmailModalOpen;

export const landingSlice = createSlice({
  name: 'landing',
  initialState: {
    resetEmailModalOpen: false,
  },
  reducers: {
    setResetEmailModalOpen: (state, action: PayloadAction<boolean>) => {
      state.resetEmailModalOpen = action.payload;
    },
  },
});

export const { setResetEmailModalOpen } = landingSlice.actions;

export default landingSlice.reducer;
